import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Invest } from '@classes/invest/invest';
import { ProviderType } from '@enums/provider-type.enum';
import { InvestService } from '@services/invest.service';

@Component({
    selector: 'app-invest-simulation',
    templateUrl: './invest-simulation.component.html',
    styleUrls: ['./invest-simulation.component.scss']
})
export class InvestSimulationComponent implements OnInit, OnDestroy {
    private investSub: Subscription;

    invest: Invest;
    providerType = ProviderType;

    constructor(
        private investSrv: InvestService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.investSub = this.investSrv.investChanged
        .subscribe(invest => {
            this.invest = invest;
        });
    }

    ngOnDestroy(): void {
        if(this.investSub) {
            this.investSub.unsubscribe();
        }
    }
}

